import { createSlice } from '@reduxjs/toolkit';
import { commonReducers, initialState } from './common';
import type { FeatureFlagConsts } from 'src/types/featureFlags';

const sliceName = 'permissions'
const { reducers, extraReducers } = commonReducers<FeatureFlagConsts>(sliceName)

// [NOTE] - Currently we only expect one permission record based on the initial LD flag values
//        - We can expand / rework this slice in the future to fit more use cases
const permissionsSlice = createSlice({
  name: sliceName,
  initialState: initialState<FeatureFlagConsts>(),
  reducers : {
    ...reducers,
  },
  extraReducers: {
    ...extraReducers,
  },
})

export default permissionsSlice
export const permissionsSliceActions = {
  ...permissionsSlice.actions,
}
